import React from 'react';
import './AccessOfferFare.scss';

export default function AccessOfferFare({ content }) {

    return (
        <div className='workshop-access_offer_fare'>
            <div className='workshop-access_offer_fare__container'>
                <h2 className='workshop-access_offer_fare__title'>{content.TitreAtelier}</h2>
                <p className='workshop-access_offer_fare__price'>{content.Tarif}</p>
                <p className='workshop-access_offer_fare__price_sub'>{content.Note}</p>
            </div>
        </div>
    )
}